/** @format */

import React, { useEffect, useId, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { assetsPath } from "../utils/assetsPath";

const DateField = ({
  register,
  errors,
  prefix = "",
  prefixClass = "",
  watch,
  control,
  className,
  className2,
  yearOptionFunction,
  claimTick,

  label = "Date of birth",
}) => {
  const [isDateValid, setIsDateValid] = useState(false);

  const months = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const dayOptions = Array.from({ length: 31 }, (_, i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString(),
  }));
  const getYearOptions = (startYear, count) => {
    return Array.from({ length: count }, (_, i) => {
      const year = startYear - i;
      return { value: year.toString(), label: year.toString() };
    });
  };

  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 16;
  const yearOptions = yearOptionFunction
    ? yearOptionFunction(currentYear)
    : getYearOptions(startYear, 100);

  const day = watch(`${prefix}Day`);

  const month = watch(`${prefix}Month`);
  const year = watch(`${prefix}Year`);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#e8e8e8 " : "white",
      "&:hover": {
        backgroundColor: "lightgray",
      },
      color: state.isSelected ? "#676363" : "black",
      backgroundColor: state.isSelected ? "lightgray" : "white",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "black" : "black",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "black" : "inherit",
    }),
  };

  useEffect(() => {
    if (
      day &&
      month &&
      year &&
      !errors[`${prefix}Day`] &&
      !errors[`${prefix}Month`] &&
      !errors[`${prefix}Year`]
    ) {
      setIsDateValid(true);
    } else {
      setIsDateValid(false);
    }
  }, [day, month, year, errors, prefix]);

  const reorderOptions = (selectedOption, options) => {
    if (!selectedOption) return options;
    return [
      selectedOption,
      ...options.filter((opt) => opt.value !== selectedOption.value),
    ];
  };

  const reorderedMonths = reorderOptions(month, months);
  const reorderedDays = reorderOptions(day, dayOptions);
  const reorderedYears = reorderOptions(year, yearOptions);

  return (
    <div>
      <label htmlFor={`${prefix}dob`} className="labelName">
        {label}
      </label>
      <div className={`licField ${className2}`}>
        <RenderSelect
          id={"Day"}
          className="day"
          placeholder="Day"
          styles={customStyles}
          options={dayOptions}
          control={control}
          register={register}
          errors={errors}
          prefix={prefix}
          SlectClasses={{
            menu: (state) => `${prefixClass}DaySelect`,
            menuList: (state) => "DaySelectDay",
          }}
        />
        <RenderSelect
          id={"Month"}
          className="month mmm"
          placeholder="Month"
          options={months}
          styles={customStyles}
          control={control}
          register={register}
          errors={errors}
          prefix={prefix}
          SlectClasses={{
            menu: (state) => `${prefixClass}Menuselect`,
            menuList: (state) => "MenuselectMenu",
          }}
        />
        <RenderSelect
          id={"Year"}
          className="year custom-select-menu "
          placeholder="Year"
          options={yearOptions}
          control={control}
          styles={customStyles}
          register={register}
          errors={errors}
          prefix={prefix}
          SlectClasses={{
            menu: (state) => `${prefixClass}Yearselect _yearMenu`,
            menuList: (state) => "YearselectYear",
          }}
        />
        {isDateValid && (
          <img
            src={assetsPath.tick}
            alt="Tick Icon"
            className={`tickIcon ${claimTick} tickDate ${className}`}
          />
        )}
      </div>
    </div>
  );
};

export default DateField;

function RenderSelect({
  id,
  className,
  register,
  errors,
  prefix,
  options,
  control,
  placeholder,
  styles,
  SlectClasses,
}) {
  const [isInputClicked, setIsInputClicked] = useState(true);

  const generateId = () => {
    if (typeof window !== "undefined") {
      return `react-select-${Math.random()
        .toString(36)
        .substr(2, 9)}`;
    }
    return null;
  };

  useEffect(() => {
    generateId();
  }, []);

  return (
    <div
      data-clicked={isInputClicked ? "true" : "false"}
      className="select margin-bottom-15"
    >
      <Controller
        control={control}
        name={`${prefix}${id}`}
        rules={{ required: true }}
        render={({ field }) => (
          <Select
            isSearchable={false}
            className={className}
            styles={styles}
            classNames={SlectClasses}
            value={options.find((option) => option.value === field.value) || ""}
            onChange={(option) => field.onChange(option.value)}
            placeholder={placeholder}
            options={options}
            id={`${prefix}${id}`}
            instanceId={useId()}
          />
        )}
      />
      {errors[`${prefix}${id}`] && <span className="errorField">Required</span>}
    </div>
  );
}
